import { SmartFieldProjectExperience } from "./SmartFieldProjectExperience";
import { SmartFieldKeyPersonnel } from "./SmartFieldKeyPersonnel";
import { SmartFieldCorporateDocument } from "./SmartFieldCorporateDocument";

export const SmartFieldQuestionnaire = ({
	smartField,
	isClientPreview,
	answer,
	...props
}) => {
	// Render the appropriate component based on smartField
	switch (smartField) {
		case "Project Experience":
			return (
				<SmartFieldProjectExperience
					isClientPreview={isClientPreview}
					answer={answer}
					{...props}
				/>
			);
		case "Key Personnel":
			return (
				<SmartFieldKeyPersonnel
					isClientPreview={isClientPreview}
					answer={answer}
					{...props}
				/>
			);
		case "Corporate Documents":
			return (
				<SmartFieldCorporateDocument
					isClientPreview={isClientPreview}
					answer={answer}
					{...props}
				/>
			);
		default:
			return <div>Unknown smart field type: {smartField}</div>;
	}
};
